import type { ReactElement, ReactNode } from 'react';

import styles from './AutoCompleteMobileTrigger.module.css';

type AutoCompleteMobileTriggerProps = {
  displayText: string;
  isEmpty?: boolean;
  isAiSearchFetching?: boolean;
  onClick: () => void;
  ariaLabel: string;
  endAdornment: ReactNode;
  'data-testid'?: string;
};

export const AutoCompleteMobileTrigger = ({
  displayText,
  isEmpty = false,
  isAiSearchFetching = false,
  onClick,
  ariaLabel,
  endAdornment,
  'data-testid': dataTestId = 'search-components_autocomplete_input',
}: AutoCompleteMobileTriggerProps): ReactElement => (
  <div className={styles.container} aria-busy={isAiSearchFetching}>
    <button
      className={styles.button}
      type="button"
      disabled={isAiSearchFetching}
      aria-label={ariaLabel}
      onClick={onClick}
      data-testid={dataTestId}
    >
      <span className={styles.buttonText} data-empty={isEmpty}>
        {displayText}
      </span>
    </button>
    <div className={styles.buttonEndAdornment} onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
      {endAdornment}
    </div>
  </div>
);
